export default __webpack_public_path__ + "static/media/esd_diode.55d42e4a.svg";